import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { TABLASPERSONALIZADAS_MAIN, TABLASPERSONALIZADAS_UNICO } from 'constants/codigosTransacciones'

import UnicoPage from './unico/lista'
import MainPage from './tablasPersonalizadas'

export default function TablasPersonalizadasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${TABLASPERSONALIZADAS_MAIN}`} component={MainPage} />
        <Route path={`/${TABLASPERSONALIZADAS_UNICO}/:tipoTabla`} component={UnicoPage} />
      </Switch>
    </Suspense>
  )
}
